interface ChallengeContext {
    url: string;
    params: {
        payload: string;
        JWT: string;
        transId: string;
    };
}

interface AddressShippingData {
    addressId: string;
}
interface StoreShippingData {
    physicalStoreId: number;
}
interface ShippingBundle {
    shippingMethodId: number;
    name: string;
    kind: string;
    shippingData: AddressShippingData | StoreShippingData;
}

export interface ApiPayment {
    fraude: ApiFraude; // Información de configuración de fraude
    paymentMethods: ApiPaymentMethod[];
}

export interface ApiFraude {
    merchanId: string;
    orgid: string;
    url: string;
}

export interface ApiPaymentMethod {
    billingAddressMandatory: '0' | '1'; // Indica si el método de pago requiere la introducción completa de la dirección de facturación
    channel: number; // AppId para el que está configurado
    code: ApiPaymentCode; // Id de método de pago en el maestro
    kind: ApiPaymentKind; // Identificador del formulario de entrada de datos en el maestro de formularios de pago
    name: ApiPaymentName; // Descripción del método de pago.
    paymentBloked: boolean; // Flag para indicar si el método de pago de mostrarse en frontal visible pero deshabilitado
    phonePurchaseAvailable: boolean; // Flag para indicar si el método de pago está habilitado para la venta telefónica
    section: null; // Número de sección en el que se posiciona el método de pago
    type: ApiPaymentType; // Identificador del método de pago en la tabla maestro de pago
    usedForWallet: '0' | '1'; // Flag para indicar si el método de pago está habilitado para su guardado en wallet
    expired: '0' | '1'; // Flag para indicar si el método de pago guardado en wallet está expirado o no
    usedWithGiftTicket: '0' | '1'; // Flag para indicar si se habilita su uso con ticket regalo
}

export type ApiPaymentCode =
    | '0'
    | '1' // Visa
    | '2' // Mastercard
    | '3' // American Express
    | '7' // Affinity
    | '8' // Paypal
    | '9' // Giftcard
    | '13' // Ideal
    | '16' // Cod
    | '17' // Discount
    | '29' // ApplePay
    | '30' // Alipay
    | '31' // Alipay_ICBCBTB
    | '32' // Alipay_ABCBTB
    | '33' // Alipay_CCBBTB
    | '34' // Alipay_SPDBB2B
    | '35' // Alipay_BOCB2C
    | '36' // Alipay_ICBCB2C
    | '37' // Alipay_CMB
    | '38' // Alipay_CCB
    | '39' // Alipay_ABC
    | '40' // Alipay_CIB
    | '41' // Alipay_GDB
    | '42' // Alipay_CMBC
    | '43' // Alipay_COMM
    | '44' // Alipay_CITIC
    | '45' // Alipay_HZCBB2C
    | '46' // Alipay_CEBBANK
    | '47' // Alipay_SHBANK
    | '48' // Alipay_NBBANK
    | '49' // Alipay_SPABANK
    | '50' // Alipay_FDB
    | '51' // Alipay_BJBANK
    | '52' // Alipay_SPDB
    | '53' // Alipay_BJRCB
    | '54' // AlipayInternational_VISA
    // eslint-disable-next-line no-secrets/no-secrets
    | '55' // AlipayInternational_MASTERCARD
    | '56' // AlipayInternational_JCB
    | '57' // Alipay Mobile
    | '63' // KCP Card
    | '64' // KCP Bank Transfer
    | '65' // KCP Bank Scrow
    | '69' // Pago en caja
    | '70' // POSODITX
    | '73' // Oxxo
    | '76' // CUP (ChinaPayUPOP)
    | '79' // Wechat Desktop
    | '81' // Wechat Mobile
    | '85' // Sofort
    | '86' // Bancontact
    | '88' // Bancontact QR
    | '100' // Mada;
    | '101' // GooglePlay
    | '105' // Dinners Club Installments Unique ID
    | '108' // PSE;
    | '111' // Virtual Account Indonesia
    | '113' // RuPay (India)
    | '114' // UPI (India)
    | '116' // Kpay
    | '117' // Bizum
    | '118' // Blik
    | '119' // Swish
    | '121' // NaverPay
    | '122' // Kakaopay
    | '123' // Humo
    | '124' // UZCard
    | '125'; // TROY

export type ApiPaymentKind =
    '2C2PAPM'
    | 'affinity'
    | 'Alipay_Banks'
    | 'Alipay_International'
    | 'Alipay_Mobile'
    | 'Alipay_QR'
    | 'Alipay_Wallet'
    | 'applePay'
    | 'Bancontact_card'
    | 'Bancontact_QR'
    | 'Bizum'
    | 'Blik'
    | 'ChinaPayUPOP'
    | 'cod'
    | 'credit_card_installments_uniqueID'
    | 'credit_card_installments'
    | 'credit_card'
    | 'gift_card'
    | 'googlePay'
    | 'ideal'
    | 'kaccount'
    | 'KCPCyberSource'
    | 'kinvoice'
    | 'multibanco'
    | 'OXXO_payments'
    | 'p24'
    | 'paypal'
    | 'pod'
    | 'PSE'
    | 'redirect'
    | 'Sofort_payment'
    | 'unique_id'
    | 'walletcard'
    | 'Wechat_QR'
    | 'Wechat_Quick'
    | 'Kakaopay'
    | 'NaverPay'
    | 'Humo'
    | 'Uzcard';

export enum PaymentMethodTypes {
    AFFINITY = 'affinity',
    ALIPAY_WALLET = 'Alipay_Wallet',
    ALIPAY_MOBILE = 'Alipay_Mobile',
    ALIPAY_QR = 'Alipay_QR',
    ALIPAY_INTERNATIONAL = 'Alipay_International',
    ALIPAY_BANKS = 'Alipay_Banks',
    BANCONTACT = 'Bancontact_card',
    BANCONTACT_QR = 'Bancontact_QR',
    BLIK = 'Blik',
    COD = 'COD',
    CUP = 'ChinaPayUPOP',
    CREDIT_CARD = 'credit_card',
    CREDIT_CARD_INSTALLMENTS = 'credit_card_installments',
    CREDIT_CARD_INSTALLMENTS_UNIQUEID = 'credit_card_installments_uniqueID',
    DINERS_CLUB_INSTALLMENTS = 'DinersInstallmentsUniqueID',
    GIFT_CARD = 'gift_card',
    HUMO = 'Humo',
    IDEAL = 'ideal',
    KLARNA_PAY_LATER = 'KlarnaPayLater',
    KLARNA_SLICE_IT = 'KlarnaSliceIt',
    KACCOUNT = 'kaccount',
    KINVOICE = 'kinvoice',
    KCPC = 'KCPCyberSource',
    KPAY = 'knet',
    KKPAY = 'Kakaopay',
    MULTIBANK = 'multibanco',
    NAVERPAY = 'NaverPay',
    OXXO = 'OXXO_payments',
    PAYPAL = 'paypal',
    P24 = 'p24',
    POD = 'POD',
    PSE = 'PSE',
    PAPM = '2C2PAPM',
    RUPAY = 'RuPay',
    TROY = 'Troy',
    UPI = 'unique_id',
    UPINEW = 'redirect',
    UZCARD = 'Uzcard',
    WALLET_CARD = 'walletcard',
    WECHAT = 'Wechat_Quick',
}

export enum PaymentMethodSessionTypes {
    CARDINAL = 'cardinal_session',
}

export type ApiPaymentName =
    'Affinity'
    | 'Alipay_ABC'
    | 'Alipay_ABCBTB'
    | 'Alipay_BJBANK'
    | 'Alipay_BJRCB'
    | 'Alipay_BOCB2C'
    | 'Alipay_CCB'
    | 'Alipay_CCBBTB'
    | 'Alipay_CEBBANK'
    | 'Alipay_CIB'
    | 'Alipay_CITIC'
    | 'Alipay_CMB'
    | 'Alipay_CMBC'
    | 'Alipay_COMM'
    | 'Alipay_FDB'
    | 'Alipay_GDB'
    | 'Alipay_HZCBB2C'
    | 'Alipay_ICBCB2C'
    | 'Alipay_ICBCBTB'
    | 'Alipay_NBBANK'
    | 'Alipay_SHBANK'
    | 'Alipay_SPABANK'
    | 'Alipay_SPDB'
    | 'Alipay_SPDBB2B'
    | 'Alipay'
    | 'AlipayInternational_JCB'
    // eslint-disable-next-line no-secrets/no-secrets
    | 'AlipayInternational_MASTERCARD'
    | 'AlipayInternational_VISA'
    | 'AMEX'
    | 'Apple Pay'
    | 'Bancontact QR'
    | 'Bank Escrow'
    | 'Bank Transfer'
    | 'Bizum'
    | 'BLIK'
    | 'CUP'
    | 'Discount'
    | 'Diners Club'
    | 'GiftCard'
    | 'GooglePay'
    | 'Humo'
    | 'Kpay'
    | 'Kakaopay'
    | 'MasterCard'
    | 'NaverPay'
    | 'P24'
    | 'Pago en Caja'
    | 'PayPal'
    | 'Paypal'
    | 'POSODITX'
    | 'PSE'
    | 'RuPay'
    | 'Sofort'
    | 'Troy'
    | 'UPI'
    | 'Uzcard'
    | 'Virtual Account Bank Transfer'
    | 'VISA'
    | 'Wechat QR'
    | 'WechatMobile'
    | '직원할인';

export type ApiPaymentType =
    'Affinity'
    | 'Alipay_ABC'
    | 'Alipay_ABCBTB'
    | 'Alipay_BJBANK'
    | 'Alipay_BJRCB'
    | 'Alipay_BOCB2C'
    | 'Alipay_CCB'
    | 'Alipay_CCBBTB'
    | 'Alipay_CEBBANK'
    | 'Alipay_CIB'
    | 'Alipay_CITIC'
    | 'Alipay_CMB'
    | 'Alipay_CMBC'
    | 'Alipay_COMM'
    | 'Alipay_FDB'
    | 'Alipay_GDB'
    | 'Alipay_HZCBB2C'
    | 'Alipay_ICBCB2C'
    | 'Alipay_ICBCBTB'
    | 'Alipay_NBBANK'
    | 'Alipay_SHBANK'
    | 'Alipay_SPABANK'
    | 'Alipay_SPDB'
    | 'Alipay_SPDBB2B'
    | 'Alipay'
    | 'AlipayInternational_JCB'
    // eslint-disable-next-line no-secrets/no-secrets
    | 'AlipayInternational_MASTERCARD'
    | 'AlipayInternational_VISA'
    | 'AMEX'
    | 'ApplePay'
    | 'BancontactQR'
    | 'Bizum'
    | 'BLIK'
    | 'ChinaPayUPOP'
    | 'Discount'
    | 'DinersInstallmentsUniqueID'
    | 'EmployeeDiscount'
    | 'GiftCard'
    | 'GooglePay'
    | 'Humo'
    | 'Kakaopay'
    | 'KCPBankEscrow'
    | 'KCPBankTransfer'
    | 'KCPCreditCard'
    | 'knet'
    | 'NaverPay'
    | 'MasterCard'
    | 'MIRCard'
    | 'P24'
    | 'PayPal'
    | 'POSITX'
    | 'POSODITX'
    | 'PSE'
    | 'RuPay'
    | 'Sofort'
    | 'Troy'
    | 'UPI'
    | 'Uzcard'
    | 'VirtualAccount'
    | 'VISA'
    | 'WechatMobile'
    | 'WechatQR';

export interface ApiWalletCard {
    affinityEmployee: boolean;
    alias: string;
    BIN?: string;
    defaultCard: boolean;
    expired: '0' | '1';
    expiredDate: string;
    hash: string;
    holderName: string;
    paymentCode: '0' | '1';
    paymentCodeName: ApiPaymentName;
    paymentMethod: ApiPaymentType;
    paymentModes: any[];
    printablePan: string; // Es un string para mostrar en pantalla que solo muestra los ultimos difitos de la tarjeta
    requestPaymentDetails: '0' | '1';
    trustedAddresses: string[];
    trustedPhysicalStores?: any[];
}

export interface ApiWalletCardList {
    walletCards: ApiWalletCard[];
}

export interface ApiSubmitPaymentPayload {
    customOrderFGID?: string;
    deviceChannel?: string;
    invoice?: '0' | '1';
    paymentBundle: any;
    vatin?: string;
}

export interface ApiPaymentPayload {
    paymentMethodType: string;
    paymentMethodKind: string;
    number?: string;
    cvv2?: string;
    otp?: string;
    governmentId?: string;
    month?: number;
    year?: number;
    vatin?: string;
    holder?: string;
    paymentModeId?: string;
    phoneNumber?: string;
    prefixPhoneNumber?: string;
    amount?: number;
    balance?: number;
    variant?: string;
    transactionId?: string;
    authorizationToken?: string;
    cardHash?: string;
    eShopperCode?: string;
    bankId?: string;
    documentNumber?: string;
    documentType?: string;
    personType?: string;
    unique_id?: string;
}

export interface AsyncCheckoutOptions {
    addressId?: string;
    oneClickPayment?: boolean;
    invoice?: '0' | '1';
    vatin?: string;
    card?: ApiPaymentPayload;
    pageOk?: string;
    pageRepay?: string;
    urlOk?: string;
    urlKo?: string;
    repay?: boolean;
    repayOrderId?: number;
    password?: string;
    isJoinLife?: boolean;
    shippingBundle?: ShippingBundle;
    paymentCode?: string;
    guestToken?: string;
    orderId?: string;
    ddc?: string;
    otp?: string;
    onStart?: () => void;
    onPaymentSuccess?: () => void;
    onConfirm?: (callback: (confirm: boolean) => void) => void;
    onError?: (errorKey: string, errorMessge: string) => void;
    onAuthAgain?: (callback: (password: string) => void) => void;
    onChallenge?: (context: ChallengeContext, callback: (transactionId: string) => void) => void;
    onReferred?: (url: any, params: any) => void;
}
